var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order" }, [
    _c("div", { staticClass: "head", on: { click: _vm.showCheckadd } }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.checkADD.id
        ? _c("div", { staticClass: "head_con" }, [
            _c("p", { staticClass: "con_address" }, [
              _vm._v(_vm._s(_vm.checkADD.addressDesc))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "con_name" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.checkADD.contactName) +
                  " " +
                  _vm._s(_vm.checkADD.contactPhone) +
                  "\n      "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.checkADD.id
        ? _c("div", { staticClass: "set_con" }, [
            _vm._v("\n      填写收货信息\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(1)
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "goods_list" },
      [
        _c("div", { staticClass: "list_title" }, [
          _vm._v("\n      商品信息\n    ")
        ]),
        _vm._v(" "),
        _vm._l(_vm.list, function(item, index) {
          return _c("div", { key: index, staticClass: "list_item" }, [
            _c("div", { staticClass: "item_img" }, [
              _c("img", {
                attrs: {
                  src: item.imgUrl
                    ? item.imgUrl
                    : "../../static/image/bgimg.png"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item_center" }, [
              _c("p", { staticClass: "center_tit" }, [
                _vm._v(_vm._s(item.name))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "center_price" }, [
                _vm._v("\n          ￥" + _vm._s(item.normalPrice)),
                _c("span", [
                  _vm._v(
                    "x" + _vm._s((item.cartInfo && item.cartInfo.number) || 0)
                  )
                ])
              ])
            ])
          ])
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "distribution" }, [
      _c("p", { staticClass: "distribution_tit" }, [_vm._v("配送费")]),
      _vm._v(" "),
      _c("p", { staticClass: "distribution_content" }, [
        _vm._v("￥" + _vm._s(_vm.saleTempInfo.deliveryCost))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "distribution" }, [
      _c("p", { staticClass: "distribution_tit" }, [_vm._v("配送规则")]),
      _vm._v(" "),
      _c("p", { staticClass: "distribution_content" }, [
        _vm._v(_vm._s(_vm.saleTempInfo.deliveryDesc))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticStyle: { "padding-bottom": "100px" } }),
    _vm._v(" "),
    _c("div", { staticClass: "footers" }, [
      _c("div", { staticClass: "car" }, [
        _c("p", { staticClass: "totle" }, [
          _vm._v("\n        合计\n        "),
          _c("span", { staticClass: "totle_money" }, [
            _vm._v("￥" + _vm._s(_vm.totleMoney))
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "jiesuan",
          on: {
            click: function($event) {
              _vm.showCheckPay = true
            }
          }
        },
        [_vm._v("\n      确认支付\n    ")]
      )
    ]),
    _vm._v(" "),
    _vm.showAddress || _vm.showCheckPay
      ? _c("div", { staticClass: "mask", on: { click: _vm.hidemask } })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.showAddress ? "shopingCarShow" : "shopingCar" },
      [
        _c("p", { staticClass: "add_title" }, [_vm._v("选择收货地址")]),
        _vm._v(" "),
        _vm._l(_vm.adress, function(item, index) {
          return _c("div", { key: index, staticClass: "address_item" }, [
            _c(
              "div",
              {
                staticClass: "checkbox_div",
                class: item.id == _vm.checkADD.id ? "checked_div" : "",
                on: {
                  click: function($event) {
                    return _vm.checkAddress(item)
                  }
                }
              },
              [
                item.id == _vm.checkADD.id
                  ? _c("div", { staticClass: "checkIn" })
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "head_con",
                on: {
                  click: function($event) {
                    return _vm.checkAddress(item)
                  }
                }
              },
              [
                _c("p", { staticClass: "con_address" }, [
                  _vm._v(_vm._s(item.addressDesc))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "con_name" }, [
                  _vm._v(
                    _vm._s(item.contactName) + " " + _vm._s(item.contactPhone)
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "edit_address",
                on: {
                  click: function($event) {
                    return _vm.editAdress(item)
                  }
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: require("../../static/image/edits.png"),
                    alt: ""
                  }
                })
              ]
            )
          ])
        }),
        _vm._v(" "),
        _c("div", { staticClass: "payBtn", on: { click: _vm.addAdress } }, [
          _vm._v("\n      新增收货地址\n    ")
        ])
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { class: _vm.showCheckPay ? "checkPayShow" : "checkPay" }, [
      _c("p", { staticClass: "add_title" }, [_vm._v("选择支付方式")]),
      _vm._v(" "),
      _vm.shopData.paymentTypes.indexOf("wechat") > -1
        ? _c(
            "div",
            {
              staticClass: "checkPay_item",
              on: {
                click: function($event) {
                  return _vm.checkPay(1)
                }
              }
            },
            [
              _c("div", { staticClass: "checkbox_div" }, [
                _vm.payType === 1
                  ? _c("div", { staticClass: "checkIn" })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "payType" }, [_vm._v("微信支付")])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.shopData.paymentTypes.indexOf("balance") > -1
        ? _c(
            "div",
            {
              staticClass: "checkPay_item",
              on: {
                click: function($event) {
                  return _vm.checkPay(2)
                }
              }
            },
            [
              _c("div", { staticClass: "checkbox_div" }, [
                _vm.payType === 2
                  ? _c("div", { staticClass: "checkIn" })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "payType" }, [_vm._v("余额支付")])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "payBtn", on: { click: _vm.handlePay } }, [
        _vm._v("\n      立即支付\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "Ret", on: { click: _vm.clickTab } }, [
      _c("span", [_vm._v("返回上一页")])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head_img" }, [
      _c("img", {
        attrs: { src: require("../../static/image/positions.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head_href" }, [
      _c("img", {
        attrs: { src: require("../../static/image/left.png"), alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19c8eb08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19c8eb08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/order/index.vue
// module id = null
// module chunks = 